import styled from 'styled-components';

export const TopBar = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const Logo = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
  max-width: 56rem;
  margin: 0 auto;
`;

export const Container = styled.div`
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 0 ${({ theme }) => theme.spacing.xxl};
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: ${({ theme }) => theme.spacing.xl};
`;
